import React from 'react';
import { useParams } from 'next/navigation';
import Rating from '@mui/material/Rating';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { RATING_NAME_MAP } from '@/constants/job-title';
import { JobTitleContext } from '@/context/create-context';
import { updateJobTitleVote } from '@/api/tanzhi';

const VoteCard = (props: {
  showVoteCard: boolean;
  rate: Record<string, number> | null;
}) => {
  const { showVoteCard, rate } = props;
  const context = React.useContext(JobTitleContext);
  const [rateValue, setRateValue] = React.useState<Record<string, number>>({});
  const [isVoted, setIsVoted] = React.useState<boolean>(false);

  const id = (useParams()?.id as string) || '';
  const name = context?.jobTitle?.name;

  const submit = () => {
    const rateValues = Object.values(rateValue);
    if (rateValues.length === 3 && rateValues.every((item) => !!item)) {
      updateJobTitleVote(id, rateValue).then(() => {
        setIsVoted(true);
      });
    }
  };

  React.useEffect(() => {
    if (rate) {
      setRateValue(rate);
    }
  }, [rate]);

  if (!showVoteCard) {
    return null;
  }

  return (
    <>
      <div className="p-8 comm-border-primary rounded-lg mb-6 bg-white tablet:mb-7.5">
        <div>
          <h3 className="mb-4 text-base tablet:text-sm tablet:mb-5">
            你认为{name}职位
          </h3>
          {Object.keys(RATING_NAME_MAP).map((key) => {
            return (
              <div className="my-3 flex items-center" key={key}>
                <span className="mr-4 text-base tablet:text-sm">
                  {RATING_NAME_MAP[key]}
                </span>
                <Rating
                  name={key}
                  className="text-dark-cyan"
                  size="small"
                  onChange={(e, value) => {
                    value &&
                      setRateValue({
                        ...rateValue,
                        [key]: Number((value * 2).toFixed(1)),
                      });
                  }}
                  emptyIcon={<StarBorderIcon fontSize="inherit" />}
                  value={
                    rateValue ? Number((rateValue[key] / 2).toFixed(1)) : null
                  }
                  key={key}
                  precision={0.5}
                  readOnly={isVoted}
                />
                <span className="ml-4 text-denim font-medium text-base tablet:text-sm">
                  {rateValue && rateValue[key]
                    ? (rateValue[key] / 2).toFixed(1)
                    : ''}
                </span>
              </div>
            );
          })}
          <div className="mt-4 tablet:mt-6">
            <button
              className="font-medium text-denim text-base tablet:text-sm"
              onClick={isVoted ? () => {} : submit}
            >
              {isVoted ? '已提交成功，谢谢！' : '提交'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default VoteCard;
